import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyARZirTYUG6MTq2rS1We7HY96XSvIiOicU',
  authDomain: 'shambalang-apps.firebaseapp.com',
  projectId: 'shambalang-apps',
  storageBucket: 'shambalang-apps.appspot.com',
  messagingSenderId: '303376605737',
  appId: '1:303376605737:web:e4764d8a052c3dc2563238'
}

// init firebase
firebase.initializeApp(firebaseConfig)

const projectAuth = firebase.auth()
const projectFirestore = firebase.firestore()

const timestamp = firebase.firestore.FieldValue.serverTimestamp

export { projectAuth, projectFirestore, timestamp }
